<template>
  <div>
    <div class="content">
      <ck-editor v-show="!textPreview" ref="editor" :content="html"></ck-editor>
      <email-text-preview
        v-show="textPreview"
        ref="textPreview"
        :on-close="closeTextPreview"
      ></email-text-preview>
    </div>
    <div class="overlay"></div>
    <div class="control-bar">
      <div class="control-buttons">
        <div
          v-if="$can('updateProjectItem')"
          class="control-button"
          @click="save"
        >
          <i class="icon-check" />
          Save
        </div>
        <div class="control-button" @click="openTextPreview">
          <i class="icon-doc-text" />
          Text Preview
        </div>
        <div class="control-button" @click="sendTest">
          <i class="icon-doc-text" />
          Test Send
        </div>
        <div class="control-button" @click="confirmClose">
          <i class="icon-cancel" />
          Discard
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CkEditor from 'vendor/ckeditor/editor'
import EmailTextPreview from './EmailTextPreview'

export default {
  name: 'EmailHtmlEditor',
  components: { CkEditor, EmailTextPreview },
  props: {
    html: String,
    onSave: Function,
    onClose: Function,
    onConfirmClose: Function,
    onSendTest: Function,
    generateTextPreview: Function
  },

  data: () => {
    return {
      textPreview: false
    }
  },

  methods: {
    save() {
      if (this.onSave) {
        this.onSave(this.$refs.editor.updatedContent())
      }
    },

    close() {
      if (this.onClose) {
        this.onClose()
      }
    },

    openTextPreview() {
      this.textPreview = true
      this.$refs.textPreview.text = ''
      this.$refs.textPreview.loading = true

      let html = this.$refs.editor.updatedContent()
      this.generateTextPreview(html, text => {
        this.$refs.textPreview.text = text
        this.$refs.textPreview.loading = false
      })
    },

    updateTextPreview(html) {
      this.generateTextPreview(html, text => {
        this.$refs.textPreview.text = text
        this.$refs.textPreview.loading = false
      })
    },

    closeTextPreview() {
      this.textPreview = false
    },

    sendTest() {
      this.onSendTest(this.$refs.editor.updatedContent())
    },

    confirmClose() {
      if (this.$refs.editor.isChanged) {
        this.onConfirmClose()
      } else {
        this.close()
      }
    }
  }
}
</script>

<style scoped>
.overlay {
  position: fixed;
  z-index: 9990;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: #32373a;
}
.content {
  position: fixed;
  z-index: 9991;
  top: 55px;
  left: 0;
  right: 0;
  bottom: 0;
}
.control-bar {
  position: fixed;
  z-index: 9992;
  top: 0;
  left: 0;
  right: 0;
  height: 55px;
  background: #505659;
  padding: 0 20px;
}
.control-buttons {
  float: left;
}
.control-button {
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  float: left;
  height: 55px;
  line-height: 55px;
  font-size: 14px;
  color: #ffffff;
  padding: 0 5px;
  margin-right: 20px;
}
.control-button:hover {
  opacity: 0.8;
}
</style>



// WEBPACK FOOTER //
// src/common/components/email/EmailHtmlEditor.vue